import React from 'react'
import SliderDetail from '@components/sliderDetail/1'
import { RealEstateDataPageComponentData } from 'types'
import './index.scss'

interface ExternalProps {
  propertyID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const SliderVideosProperty = ({
  propertyID,
  title,
  global_data,
  alignCenter,
  upperCaseLink,
  titleSecondary,
}: CombinedProps) => {
  return (
    <section className="property-videos a">
      <SliderDetail
        propertyID={propertyID}
        title={title}
        type={'videos'}
        global_data={global_data}
        alignCenter={alignCenter}
        upperCaseLink={upperCaseLink}
        titleSecondary={titleSecondary}
      />
    </section>
  )
}

export default SliderVideosProperty
